import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import news1 from '../../assets2/news1.png';
import news2 from '../../assets2/news2.png';
import news3 from '../../assets2/news3.png';
import news4 from '../../assets2/news4.png';
import aboutBg from '../../assets2/backgrounds/about-bg.png';
import './News.css';

const News = () => {
  const navigate = useNavigate();
  
  // Static plant data for customer viewing - no admin modification needed
  const plants = [
    {
      id: 1,
      image: news1,
      name: "Drosera paleacea 'True Type'",
      price: 25.00,
      availability: "Limited Availability",
      status: "available",
      description: "A stunning sundew with unique paleaceous appearance. Perfect for beginners."
    },
    {
      id: 2,
      image: news2,
      name: "Drosera scorpioides",
      price: 20.00,
      availability: "Limited Availability", 
      status: "available",
      description: "Small but beautiful sundew with distinctive tail-like leaves."
    },
    {
      id: 3,
      image: news3,
      name: "Nepenthes ventricosa",
      price: 35.00,
      availability: "Sold Out",
      status: "soldout",
      description: "Hardy tropical pitcher plant ideal for intermediate growers."
    },
    {
      id: 4,
      image: news4,
      name: "Sarracenia purpurea",
      price: 30.00,
      availability: "In Stock",
      status: "available",
      description: "North American pitcher plant that thrives in outdoor bog gardens."
    }
  ];

  const handleBuyNow = (plantName) => {
    navigate('/contact');
  };

  const handleNotifyAvailable = () => {
    // Redirect to contact page for restock notifications
    navigate('/contact');
  };

  const handleAddToWishlist = (plantId) => {
    // In a real app, this would save to user's wishlist
    alert('Added to wishlist! (Feature coming soon)');
  };

  return (
    <div className="news-container">
      <div className="news-hero">
        <div className="news-hero-background">
          <img src={aboutBg} alt="Background" />
          <div className="news-hero-overlay"></div>
        </div>
        <div className="news-hero-content">
          <h1>Plant Shop</h1>
          <p>Discover our collection of rare and exotic plants available for purchase</p>
        </div>
      </div>
      
      <div className="news-content">
        <div className="shop-grid">
          {plants.map((plant) => (
            <div key={plant.id} className={`shop-item ${plant.status}`}>
              <div className="plant-image">
                <img src={plant.image} alt={plant.name} />
                <div className={`availability-badge ${plant.status}`}>
                  {plant.availability}
                </div>
              </div>
              <div className="plant-info">
                <h3 className="plant-name">{plant.name}</h3>
                <div className="plant-price">${plant.price.toFixed(2)}</div>
                <div className="plant-availability">{plant.availability}</div>
                <p className="plant-description">{plant.description}</p>
                
                <div className="plant-actions">
                  {plant.status === 'available' ? (
                    <>
                      <button 
                        className="buy-btn primary"
                        onClick={() => handleBuyNow(plant.name)}
                      >
                        Buy Now
                      </button>
                      <button 
                        className="wishlist-btn secondary"
                        onClick={() => handleAddToWishlist(plant.id)}
                      >
                        ♡ Add to Wishlist
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="buy-btn disabled" disabled>
                        Currently Unavailable
                      </button>
                      <button 
                        className="notify-btn secondary"
                        onClick={() => handleNotifyAvailable()}
                      >
                        Notify When Available
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="shop-cta">
          <h2>Interested in a Plant?</h2>
          <p>Contact us to inquire about availability or to place an order</p>
          <div className="contact-buttons">
            <a href="/contact" className="contact-btn primary">Contact Us</a>
            <a href="mailto:canopy.systems1@gmail.com" className="contact-btn secondary">Email Directly</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
